import OpenTaskClient from "./task-open-client";

type TaskOpenPageProps = {
  searchParams: URLSearchParams;
};

export default function TaskOpenPage({ searchParams }: TaskOpenPageProps) {
  return (
    <OpenTaskClient
      processInstanceId={searchParams.get("processInstanceId") ?? ""}
      taskDefinitionKey={searchParams.get("taskDefinitionKey") ?? ""}
      sentAt={searchParams.get("sentAt") ?? ""}
    />
  );
}
